<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row>
            <div style="position: fixed; z-index: 1;  background-color: white; width: 100%; top:55px;">
            <v-breadcrumbs :items="items" large style=" font-weight: 600; letter-spacing: 1px; ">

            </v-breadcrumbs>
            </div>
        </v-row><br><br><br />
        <v-skeleton-loader v-if="overlay" v-bind="attrs" type="article"></v-skeleton-loader>
        <v-card v-else class="card">
            <v-card-title class="justify-center grey white--text">PAY FINE</v-card-title>
            <br />



            <div v-if="userInfo" class="cus-card">
                <v-row no-gutters>
                    <v-col cols="12" sm="10" md="10">
                        <v-row no-gutters>
                            <v-col cols="12" sm="4" md="4">
                                <v-row no-gutters>
                                    <v-col cols="12" sm="4" md="4">
                                        <label class="c-label">Reg/Emp Code</label>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="8">
                                        <span>: {{ empmemberinfo.reg_no }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="8" md="8">
                                <v-row no-gutters>
                                    <v-col cols="12" sm="4" md="4">
                                        <label class="c-label">Name</label>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="8">
                                        <span>: {{ empmemberinfo.name }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-row no-gutters>
                                    <v-col cols="12" sm="4" md="4">
                                        <label style="padding: 0; margin: 0" class="c-label">Contact</label>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="8">
                                        <span style="padding: 0; margin: 0">: {{
                                            empmemberinfo.mobile_number }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="8" md="8">
                                <v-row no-gutters>
                                    <v-col cols="12" sm="4" md="4">
                                        <label class="c-label">Email</label>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="8">
                                        <span style="padding: 0; margin: 0">: {{
                                            empmemberinfo.email }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-row no-gutters>
                                    <v-col cols="12" sm="4" md="4">
                                        <label class="c-label">User Type</label>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="8">
                                        <span>: {{ empmemberinfo.usertype }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col v-if="empmemberinfo.program != ''" cols="12" sm="8" md="8">
                                <v-row no-gutters>
                                    <v-col cols="12" sm="4" md="4">
                                        <label class="c-label">Program</label>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="8">
                                        <span style="padding: 0; margin: 0">: {{ empmemberinfo.program }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col v-if="empmemberinfo.rollno != ''" cols="12" sm="4" md="4">
                                <v-row no-gutters>
                                    <v-col cols="12" sm="4" md="4">
                                        <label class="c-label">Roll No</label>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="8">
                                        <span style="padding: 0; margin: 0">: {{ empmemberinfo.rollno }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col v-if="empmemberinfo.division != ''" cols="12" sm="8" md="8">
                                <v-row no-gutters>
                                    <v-col cols="12" sm="4" md="4">
                                        <label class="c-label">Division</label>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="8">
                                        <span style="padding: 0; margin: 0">: {{ empmemberinfo.division }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col v-if="empmemberinfo.year" cols="12" sm="4" md="4">
                                <v-row no-gutters>
                                    <v-col cols="12" sm="4" md="4">
                                        <label class="c-label">Year</label>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="8">
                                        <span style="padding: 0; margin: 0">: {{ empmemberinfo.year }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-img height="150" width="150" :src="url">
                            <template v-slot:placeholder>
                                <v-icon size="150">mdi mdi-account</v-icon>
                            </template>
                        </v-img>
                    </v-col>
                </v-row>


            </div>

        </v-card>
        <br />

        <div v-if="Array.isArray(fineRecord) && fineRecord.length">
            <v-card>

                <center class="red--text">
                    <h2> Total Fine</h2>
                </center>





                <v-row justify="center" align="center">

                    <v-col cols="12" sm="1" md="1">

                        <v-card class="grey white--text">
                            <center>{{ actual_total_fine }}</center>
                        </v-card>
                    </v-col>
                </v-row>
                <br />



            </v-card>
            <v-card>
                <v-simple-table class="pa-3 ">
                    <thead style="text-align:center;" class="grey white--text">
                        <th style="text-align:center; position: sticky; top: 0;" class="pa-2"> Sr. No </th>
                        <th class="pa-2"> Accession No </th>
                        <th class="pa-2"> Title </th>
                        <th class="pa-2"> Issue Date </th>
                        <th class="pa-2"> Due Date </th>
                        <th class="pa-2"> Return Date</th>
                        <th class="pa-2"> Actual Fine </th>



                    </thead>
                    <tbody style="text-align:center;">
                        <tr v-for="(item, index) in fineRecord" :key="index">
                            <td class="pa-2">{{ index + 1 }}</td>
                            <td class="pa-2">{{ item.acc_no }}</td>
                            <td class="pa-2">{{ item.title }}</td>
                            <td class="pa-2">{{ item.br_date }}</td>
                            <td class="pa-2">{{ item.due_date }}</td>
                            <td class="pa-2">{{ item.return_date }}</td>
                            <td class="pa-2">{{ item.fine }}</td>

                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card>
            <br />

        </div>
        <div v-if="no_fine">
            <v-card class="green white--text">
                <center class="ma-1 pa-1">
                    <h3> No Fine Found.</h3>
                </center>
            </v-card>
        </div>




    </div>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {

            actual_total_fine: 0,
            total_amount_paid: 0,
            loading_fine: false,
            overlay: false,
            overlay_fine: false,
            color: "",
            snackbar: false,
            snackbar_msg: "",
            isempselected: true,
            prn: "",
            userInfo: false,
            url: "",
            isphoto: false,
            selecteduser: "",
            empmemberlist: "",
            fineRecord: [],
            items: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    href: '/home',
                },
                {
                    text: localStorage.getItem("jhhjbyj"),
                    disabled: false,
                    href: '/sublink',
                },
                {
                    text: 'View Fine',
                    disabled: true,
                    href: 'breadcrumbs_link_2',
                },
            ],
            reciept_no: "",
            no_fine: false,
            rules: {
                required: (value) => !!value || "Required.",
            },
        };
    },
    mounted() {
        // this.getfine("119B1128");
        // this.prn='119B1129';
        this.init();
    },
    methods: {



        getfine(value) {
            this.fineRecord = [];
            this.no_fine = false;
            this.reciept_no = "";
            this.overlay_fine = true;
            var params = { prn: value };
            axios
                .post("/IssueBook/getFineNew", params)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.fineRecord = res.data.fineRecord;
                        this.actual_total_fine = res.data.total_fine;
                        this.total_amount_paid = res.data.total_fine;
                        this.overlay_fine = false;

                    }
                    if (res.data.status == "504") {
                        this.no_fine = true;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                    this.overlay_fine = false;
                })
                .finally(() => {
                    this.overlay_fine = false;
                });
        },
        init() {
            this.overlay = true;
            axios
                .post("/Librarian/getMyPRN")
                .then((res) => {
                    if (res.data.status == "200") {
                        this.prn = res.data.prn;
                        this.overlay = false;
                        this.findUserInfo();
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        set1(value, person) {
            if (person == "emp") {
                this.prn = value.displayname.split(":")[0].trim();
                this.isempselected = true;
            } else if (person == "bookbarcode") {
                if (this.accno == "") this.isbookselected = false;
                else this.isbookselected = true;
            }
        },
        findUserInfo(seluser) {
            this.bookLimit = false;
            var params = null;
            // params = { userid: this.selecteduser.username };

            this.overlay1 = true;



            params = { userid: this.prn };
            axios
                .post("/IssueBook/getEmpMemInformationbyprn", params)
                .then((res) => {
                    this.overlay1 = false;
                    if (res.data.msg == "200") {
                        this.userInfo = true;
                        this.empmemberinfo = res.data.memberinfo;

                        this.getimage(this.prn);
                        this.getfine(this.prn);
                    } else {
                        this.showSnackbar("red", res.data.msg);
                        this.userInfo = false;
                    }
                });


        },
        getimage(value) {
            var params = { prn: value };
            axios
                .post("/ImportData/getphotfromerp", params)
                .then((res) => {
                    if (res.data.msg == '200') {
                        this.url = res.data.url;
                        this.isphoto = res.data.isphoto;
                    }


                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
};
</script>
<style scoped>
.centered-input>>>input {
    text-align: center
}

.add-section {
    display: block;
    margin: 1rem;
}

.text>>>.v-input__slot {
    background: white !important;
    border-color: hsla(190, 99%, 30%, 1) !important;
}

.cus-card {
    background: #d3d3d33d;
    margin: 1rem;
    padding: 1rem;
    border: 2px solid gray;
}
</style>